export default "__VITE_ASSET__DpYBYSa4__"